<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      FormErrorAlert(:message="message"
        v-if="message"
        @dismiss="message = ''")
      h1 Update Password
      ChangePasswordWidget(
        :message.sync="message"
        :username="username"
        :firstName="firstName"
        :lastName="lastName"
        @password="savePassword($event)"
      )
</template>

<script>
import ChangePasswordWidget from '@/components/ChangePasswordWidget'
import { globalSuccess } from '@/lib/utils'
import axios from '@/lib/axios'
import store from '@/store'

export default {
  name: 'UpdatePassword',
  data() {
    return {
      message: '',
    }
  },
  computed: {
    firstName() {
      return store.state.account.firstName
    },
    lastName() {
      return store.state.account.lastName
    },
    username() {
      return store.state.account.username
    }
  },
  methods: {
    savePassword({ newPassword, oldPassword }) {
      axios({ auth: false })
        .post('/api/change_password', {
          username: this.$store.state.account.username,
          oldPassword,
          password: newPassword,
        })
        .then(() => {
          this.$router.push({ name: 'login' })
          globalSuccess(null, 'Password was successfully updated.')
        })
        .catch(err => {
          this.message = err.response.data.message
        })
    },
  },
  components: {
    ChangePasswordWidget,
  },
}
</script>

<style lang="scss" scoped>
.error {
  width: 835px;
  margin: auto;
  margin-bottom: 2rem;
}
</style>